<script>
import baseMixin from '@/mixins/baseMixin'
import dayjs from '@/services/date'
import DateFormatToken from '@/constants/date/DateFormatToken'

export default {
  name: 'DisputesTableSubmittedIndicator',
  mixins: [baseMixin],
  props: {
    timesheet: {
      type: Object,
      required: true,
    },
  },
  computed: {
    compTooltipText() {
      return `Submitted on ${dayjs(this.timesheet?.submittedDateUtc)
        .locale(this.$i18n.locale)
        .format(DateFormatToken.LLLL)}`
    },
  },
}
</script>

<template>
  <div class="cursor-help">
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on">mdi-check</v-icon>
      </template>
      <span class="ws-pre-wrap">{{ compTooltipText }}</span>
    </v-tooltip>
  </div>
</template>
